import { render, staticRenderFns } from "./ShareholderItem.vue?vue&type=template&id=257362b4"
import script from "./ShareholderItem.vue?vue&type=script&lang=js"
export * from "./ShareholderItem.vue?vue&type=script&lang=js"
import style0 from "./ShareholderItem.vue?vue&type=style&index=0&id=257362b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports